<template id="report">
  <div>
    <vs-select v-validate="'required'" name="person" :label="$t('Person') |ToUppercase" class="w-full" v-model="report.personID">
        <vs-select-item
          v-for="person in persons"
          :text='person.firstname + " " + person.lastname'
          :value="person.id"
          :key="person.id"
        />
    </vs-select>
    <ReportItem :item="report.date1" vvFormScope="date1"></ReportItem>
    <ReportItem :item="report.date2" vvFormScope="date2"></ReportItem>
    <ReportItem :item="report.date3" vvFormScope="date3"></ReportItem>
    <ReportItem :item="report.date4" vvFormScope="date4"></ReportItem>
    <ReportItem :item="report.date5" vvFormScope="date5"></ReportItem>
    <ReportItem :item="report.date6" vvFormScope="date6"></ReportItem>
    <ReportItem :item="report.date7" vvFormScope="date7"></ReportItem>
    <ReportItem :item="report.date8" vvFormScope="date8"></ReportItem>
    <ReportItem :item="report.date9" vvFormScope="date9"></ReportItem>
    <ReportItem :item="report.date10" vvFormScope="date10"></ReportItem>
    <ReportItem :item="report.date11" vvFormScope="date11"></ReportItem>
    <ReportItem :item="report.date12" vvFormScope="date12"></ReportItem>
    <ReportItem :item="report.date13" vvFormScope="date13"></ReportItem>
    <ReportItem :item="report.date14" vvFormScope="date14"></ReportItem>
    <ReportItem :item="report.date15" vvFormScope="date15"></ReportItem>
    <ReportItem :item="report.date16" vvFormScope="date16"></ReportItem>
    <ReportItem :item="report.date17" vvFormScope="date17"></ReportItem>
    <ReportItem :item="report.date18" vvFormScope="date18"></ReportItem>
    <ReportItem :item="report.date19" vvFormScope="date19"></ReportItem>
    <ReportItem :item="report.date20" vvFormScope="date20"></ReportItem>
    <ReportItem :item="report.date21" vvFormScope="date21"></ReportItem>
    <ReportItem :item="report.date22" vvFormScope="date22"></ReportItem>
    <ReportItem :item="report.date23" vvFormScope="date23"></ReportItem>
    <ReportItem :item="report.date24" vvFormScope="date24"></ReportItem>
    <ReportItem :item="report.date25" vvFormScope="date25"></ReportItem>
    <ReportItem :item="report.date26" vvFormScope="date26"></ReportItem>
    <ReportItem :item="report.date27" vvFormScope="date27"></ReportItem>
    <ReportItem :item="report.date28" vvFormScope="date28"></ReportItem>
    <ReportItem :item="report.date29" vvFormScope="date29"></ReportItem>
    <ReportItem :item="report.date30" vvFormScope="date30"></ReportItem>
    <ReportItem :item="report.date31" vvFormScope="date31"></ReportItem>
  </div>
</template>
<script>
import ReportItem from './ReportTemplate3Item.vue'
export default {
  inject: ["$validator"],
  name: "report-component",
  template: "#report",
  props: {
    report: {
      type: Object
    },
    vvFormScope: {
      type: String
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  components: {
      ReportItem
  },
  computed: {
    persons(){
      console.log("Uporabniki vrnjeni");
      return this.$store.state.admin.users.slice();
    }
  },
  created() {
    this.$store.dispatch("admin/fetchUsers");
    console.log("Pridobivam uporabnike");
  }
};
</script>